import AuthShowContainer from 'modules/auth/AuthShowContainer';
import { getCurrentUser, submitData } from 'modules/data';
import { useI18n } from 'modules/i18n';
import { useProject } from 'modules/routes';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';

import { EditData, EditViewOrRedirect, Logos } from '../../components';
import MediaStreams from './MediaStreams';
import ProjectFaviconForm from './ProjectFaviconForm';
import SponsorLogos from './SponsorLogos';

export default function EditProjectDisplayPage() {
    const { t } = useI18n();
    const { project } = useProject();
    const dispatch = useDispatch();
    const user = useSelector(getCurrentUser);

    function submitHandler(props, params, opts, callback) {
        dispatch(submitData(props, params, opts, callback));
    }

    const formElements = [
        {
            attribute: 'primary_color',
            elementType: 'colorPicker',
        },
        {
            attribute: 'secondary_color',
            elementType: 'colorPicker',
        },
        {
            attribute: 'editorial_color',
            elementType: 'colorPicker',
        },
        {
            attribute: 'aspect_x',
            validate: function (v) {
                return /^\d+$/.test(v);
            },
        },
        {
            attribute: 'aspect_y',
            validate: function (v) {
                return /^\d+$/.test(v);
            },
        },
    ];

    return (
        <EditViewOrRedirect>
            <div className="wrapper-content register">
                <Helmet>
                    <title>{t(`edit.project.display`)}</title>
                </Helmet>
                <AuthShowContainer hasProjectAccess>
                    <h1 className="Page-main-title">
                        {t(`edit.project.display`)}
                    </h1>
                    <EditData
                        data={project}
                        scope="project"
                        helpTextCode="archive_display_form"
                        formElements={formElements}
                        submitData={submitHandler}
                    />
                    <ProjectFaviconForm project={project} />
                    <h2>{t(`edit.logo.admin`)}</h2>
                    <Logos />
                    <h2>{t(`edit.sponsor_logo.admin`)}</h2>
                    <SponsorLogos />
                    {user?.admin && (
                        <>
                            <h2>{t(`edit.media_stream.admin`)}</h2>
                            <MediaStreams />
                        </>
                    )}
                </AuthShowContainer>
                <AuthShowContainer ifLoggedOut={true} ifNoProject={true}>
                    {t('devise.failure.unauthenticated')}
                </AuthShowContainer>
            </div>
        </EditViewOrRedirect>
    );
}
